const UserQuery = {
  userManagement: `id name fullName nameReverse email phone invitationLink restrictions active claimed ` +
    `mealClubAutoOrder copayAllowance ` +
    `creditCards { id }`,
  mealManagement: `id fullName likes dislikes restrictions restrictedIngredients`,
}

export default UserQuery
